import script from "./GradeSimulationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./GradeSimulationPage.vue?vue&type=script&setup=true&lang=ts"

import "./GradeSimulationPage.vue?vue&type=style&index=0&id=203e797a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-203e797a"]])

export default __exports__